<template>
<div v-if="isShow">
    <div v-if="isShowStatus">
        <header>プライベートモード設定<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
        </header>
        <div id="wrap">
            <div class="porf-area">
                <table>
                    <tr>
                        <td class="b">プライベートモード</td>
                        <td class="right">
                            <div class="switch3"><label class="switch3__label"><input type="checkbox" id="private_mode_chbox" @click="savePrivateModeSetting()" class="switch3__input" /><span class="switch3__content"></span><span class="switch3__circle"></span></label></div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="txt-area">
                <div class="btn4"><a href="#" @click="showPrivateModeDetail()">プライベートモードの詳細を見る</a></div>
            </div>
        </div>
    </div>
    <div v-else>
        <header>プライベートモード<div class="h-left"><a href="#" @click="backToPrivateModeSetting()"><img src="~@/assets/images/icon02.svg"></a></div>
        </header>
        <div id="wrap">
            <img src="~@/assets/images/private01.jpg">
            <img src="~@/assets/images/private02.png">
        </div>
    </div>
</div>

<alertDialogBottom :active="isAlert">
    変更しました。
</alertDialogBottom>
<div class="loading-screen" style="opacity: 0.6" v-if="isLoading">
    <div class="loader"></div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex"
import alertDialogBottom from "@/views/components/alertDialogBottom.vue";
export default {
    props: {
        isShow: Boolean,
    },
    emits: ['close'],
    components: {
        alertDialogBottom
    },
    data: () => ({
        isShowStatus: true,
        isAlert: false,
        isLoading: true
    }),
    mounted() {
        this.loadPrivateModeSetting()
    },
    computed: {
        ...mapGetters(["metadata", 'defaultToken']),
    },
    methods: {
        loadPrivateModeSetting() {
            this.isLoading = true
            this.$store
                .dispatch("user/userIndex", {
                    token: this.defaultToken,
                })
                .then((data) => {
                    this.isLoading = false
                    document.getElementById("private_mode_chbox").checked = parseInt(
                        data.data.is_private
                    );
                })
                .catch((err) => {
                    this.isLoading = false
                    console.log(err);
                });
        },

        savePrivateModeSetting() {
            let formData = new FormData();
            formData.append(
                "is_private",
                document.getElementById("private_mode_chbox").checked ? 1 : 0
            );
            formData.append("token", this.defaultToken);

            this.$store
                .dispatch("user/userUpdate", formData)
                .then((data) => {
                    // TODO: show notice at bottom
                    this.isAlert = false
                    setTimeout(() => {
                        //Clear all Timeout
                        let id = window.setTimeout(function() {}, 0);
                        while (id--) {
                            window.clearTimeout(id); // will do nothing if no timeout with id is present
                        }

                        // Show bottom alert
                        this.isAlert = true
                        setTimeout(() => {
                            this.isAlert = false
                        }, 1000)
                    }, 50)
                })
                .catch((err) => {
                    console.log(err.response.data.message);
                });
        },
        showPrivateModeDetail() {
            this.isShowStatus = false
        },
        backToPrivateModeSetting() {
            this.isShowStatus = true
        },
        closeAlert() {
            this.isAlert = false
        },
    },
};
</script>
